import { InjectionToken } from '@angular/core';

// Base da API. Cada aplicação provê este token a partir do seu próprio environment,
// para que as bibliotecas compartilhadas não dependam de src/environments.
export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');
